/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "4a9588be027bd80d9f3852a781d9d28665077860";
